import LegacyStepper from './LegacyStepper';

export default LegacyStepper;
